import { render } from "./SubCategory.vue?vue&type=template&id=3b08e50f&scoped=true"
import script from "./SubCategory.vue?vue&type=script&lang=js"
export * from "./SubCategory.vue?vue&type=script&lang=js"

import "./SubCategory.vue?vue&type=style&index=0&id=3b08e50f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b08e50f"

export default script